//? PLUGINS //
import {
    Box,
    Button,
    Drawer,
    Grid,
    IconButton,
    SvgIcon,
    useMediaQuery,
} from "@mui/material";
import LanguageSelector from "components/language/languageSelector";
import React, { ReactElement, ReactHTMLElement, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//? COMPONENTS //
import { AuthenticatedUser } from "components/header/authenticatedUser";
import { UnknownUser } from "components/header/unknownUser";

//? EXTRAS //
import { ReactComponent as PZALogo } from "resources/PZA_Logo.svg";
import { ReactComponent as TenantLogo } from "resources/Tenant_Logo.svg";
import * as authenticationService from "services/AuthenticationService";
import * as Styles from "styles/components/header.styles";
import * as Global from "styles/global/global.styles";
// import { isMobile } from 'react-device-detect';

//? ICONS & IMAGES //
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/system";
import { useTranslation } from "react-i18next";

import { AxiosError } from "axios";
import { Message, MessageRef } from "components/messages/message";
import * as ApplicationService from "services/application-service";
import { User } from "services/AuthenticationService";
import { useAuthContext } from "contexts/authContext";
import { useTenantContext } from "contexts/tenantContext";

//! -------------------------------------------------------- //

const Header = () => {
    let navigate = useNavigate();
    const { user, isAuthenticated } = useAuthContext();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const { t } = useTranslation();
    const childRef = React.useRef<MessageRef>();
    const { currentTenant } = useTenantContext();

    // React.useEffect(() => {
    //     authenticationService.getUserAsync().then((user) => {
    //         setUser(user);
    //     });
    // }, []);

    function handleClickHome() {
        navigate("/");
    }

    function handleClickBeheer() {
        navigate("/beheer");
    }
    // TODO : add handler for second button

    const handleClickSubmitApplication = async () => {
        //* Getting Empty Dossier GUID
        await ApplicationService.getEmptyApplicationAsync()
            .then((dossierId) => {
                navigate(`aanvraag_veiligheidsverificatie_indienen/${dossierId}`);
            })
            .catch((error: AxiosError) => {
                if (error.code === "ERR_NETWORK") {
                    childRef.current?.showMessage(
                        "Er is geen internet verbinding met de server",
                        "error"
                    );
                }
            });
    };

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const isMedium = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Box component="header" sx={Styles.Container}>
            {process.env.REACT_APP_ENV !== 'production' &&
                <Box sx={{color: "red", fontWeight: "bold", fontSize: "32px", position: "absolute", left: "50%", transform: "translate(-50%, -50%)", textAlign: "center", marginTop: "65px", backgroundColor: "wheat", padding: "12px", borderRadius: "10px", zIndex: "15"}}>
                    {process.env.REACT_APP_ENV === 'showcase' && "Showcase/Demo"}
                    {process.env.REACT_APP_ENV === 'development' && "Local"}
                    {process.env.REACT_APP_ENV === 'dev' && "Development"}
                    {process.env.REACT_APP_ENV === 'acc' && "Acceptatie"}
                </Box>
            }
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                {currentTenant && currentTenant.hasLogo ? (
                    <Box
                        onClick={() => handleClickHome()}
                        sx={{ "&:hover": { cursor: "pointer" } }}
                        height={85}
                    >
                        <img src={`/logos/${currentTenant?.name}.svg`} height={85} alt={'Police logo'} />
                    </Box>
                ) : currentTenant ? (
                    <Box
                        sx={{
                            // position: 'relative',
                            display: 'flex',
                            // width: tenantRef.current ? tenantRef.current.clientWidth : 'initial',
                            // alignContent: 'center',
                            alignItems: 'center',
                            '&:hover': {
                                cursor: 'pointer',
                            },
                        }}
                        onClick={() => handleClickHome()}
                    >
                        <Box
                            sx={{
                                // marginLeft: '1.25rem',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Box
                                component={TenantLogo}
                                sx={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem',
                                    maxHeight: '84px',
                                    height: '62px',
                                    width: 'auto',
                                }}
                            />
                            <Box
                                sx={{
                                    // color: 'black',
                                    // width: tenantRef.current ? tenantRef.current.clientWidth : 'initial',
                                    // display: 'flex'
                                }}
                            >
                                <p style={{ margin: 0 }}>{currentTenant.displayName}</p>
                                {/* <p style={{margin: 0}}>dit is een lange</p> */}
                            </Box>
                        </Box>
                    </Box>
                ) : (
                    <Box
                        component={PZALogo}
                        onClick={() => handleClickHome()}
                        sx={{ "&:hover": { cursor: "pointer" } }}
                    />
                )}

                {isAuthenticated() && !isMedium && (
                    <Box
                        sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
                    >
                        <Box sx={{ ml: "20px" }}>
                            <Button variant="contained" onClick={() => handleClickBeheer()}>
                                {t("header.manage")}
                            </Button>
                        </Box>
                        {/* <Box sx={{ml: '15px'}}>
							<Button variant="contained">Beheer</Button>
						</Box> */}
                    </Box>
                )}
            </Box>

            {isMobile ? (
                <Box>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={() => setIsDrawerOpen(!isDrawerOpen)}
                        sx={{ mr: 2, display: { xs: "block", md: "none", zIndex: 1201 } }}
                    >
                        <MenuIcon
                            sx={{ fontSize: "40px", color: Global.colors().headers }}
                        />
                    </IconButton>

                    <Drawer
                        anchor="right"
                        variant="temporary"
                        open={isDrawerOpen}
                        onClose={() => setIsDrawerOpen(false)}
                    >
                        {/* //? CONTAINER */}
                        <Box
                            sx={{
                                backgroundColor: Global.colors().__footer.footerBackground,
                                width: "70vw",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                paddingBottom: "1rem",
                                height: "100%",
                                overflowY: "auto",
                                maxWidth: "450px",
                            }}
                        >
                            <AccountCircleIcon
                                sx={{
                                    width: "30vh",
                                    height: "30vw",
                                    mt: "15px",
                                    color: "#FFF",
                                    maxHeight: "150px",
                                }}
                            />
                            <Box sx={{ fontSize: "15px", color: "#FFF" }}>
                                {t("hamburger.greeting")}
                            </Box>
                            {user && isAuthenticated() ? (
                                <Box sx={{ fontSize: "20px", color: "#FFF" }}>
                                    {user.given_name} {user.surname}
                                </Box>
                            ) : (
                                <Box sx={{ fontSize: "20px", color: "#FFF" }}>
                                    {t("hamburger.guest")}
                                </Box>
                            )}

                            <Box
                                sx={{
                                    border: "1px solid #e5e5e5",
                                    width: "calc(100% - 1px)",
                                    my: "2rem",
                                }}
                            />

                            <Grid container spacing={3} sx={{ px: "3rem" }}>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{
                                        color: "#FFF",
                                        fontSize: "20px",
                                        textAlign: "start",
                                        "&:hover": { cursor: "pointer" },
                                    }}
                                    onClick={() => {
                                        setIsDrawerOpen(false);
                                        handleClickHome();
                                    }}
                                >
                                    {t("hamburger.home")}
                                </Grid>
                                {user && isAuthenticated() ? (
                                    <Grid
                                        item
                                        xs={12}
                                        sx={{
                                            color: "#FFF",
                                            fontSize: "20px",
                                            textAlign: "start",
                                            "&:hover": { cursor: "pointer" },
                                        }}
                                        onClick={() => {
                                            setIsDrawerOpen(false);
                                            handleClickBeheer();
                                        }}
                                    >
                                        {t("header.manage")}
                                    </Grid>
                                ) : (
                                    ""
                                )}
                                <Grid
                                    item
                                    xs={12}
                                    sx={{
                                        color: "#FFF",
                                        fontSize: "20px",
                                        textAlign: "start",
                                        "&:hover": { cursor: "pointer" },
                                    }}
                                    onClick={() => {
                                        setIsDrawerOpen(false);
                                        handleClickSubmitApplication();
                                    }}
                                >
                                    {t("hamburger.buttonLeft")}
                                </Grid>
                                {/* <Grid item xs={12} sx={{ color: '#FFF', fontSize: '20px', textAlign: 'start', "&:hover": { cursor: 'pointer' } }} onClick={() => { setIsDrawerOpen(false); }}>{t('hamburger.buttonRight')}</Grid> */}
                                <Grid item xs={12}>
                                    <Box sx={{ borderTop: "1px solid #e5e5e5", my: "1rem" }} />
                                </Grid>
                                {user && isAuthenticated() && (
                                    <Grid item xs={12}>
                                        <AuthenticatedUser user={user} isMobile={isMobile} />
                                    </Grid>
                                )}
                                {user && isAuthenticated() && (
                                    <Grid item xs={12}>
                                        <Box sx={{ borderTop: "1px solid #e5e5e5", my: "1rem" }} />
                                    </Grid>
                                )}
                                <Grid item xs={12}>
                                    <LanguageSelector isMobile={isMobile} />
                                </Grid>
                                {/* <Grid item xs={12}>{authenticationService.isAuthenticated(user) ? <AuthenticatedUser user={user} isMobile={isMobile} /> : <UnknownUser navigate={navigate} isMobile={isMobile} setIsDrawerOpen={setIsDrawerOpen} />}</Grid> */}
                            </Grid>

                            {/* {authenticationService.isAuthenticated(user) ? <AuthenticatedUser user={user} isMobile={isMobile} /> : <UnknownUser navigate={navigate} />} */}
                            {/* <LanguageSelector isMobile={isMobile} /> */}
                        </Box>
                    </Drawer>
                    <Message ref={childRef} />
                </Box>
            ) : (
                <Box sx={Styles.LoginIslandContainer}>
                    {/* {authenticationService.isAuthenticated(user) ? <AuthenticatedUser user={user} isMobile={isMobile} /> : <UnknownUser navigate={navigate} isMobile={isMobile} setIsDrawerOpen={setIsDrawerOpen} />} */}
                    {user && isAuthenticated() && (
                        <AuthenticatedUser user={user} isMobile={isMobile} />
                    )}
                    {/* <AuthenticatedUser user={user? user : {} as User} isMobile={isMobile} /> */}

                    <LanguageSelector isMobile={isMobile} />
                </Box>
            )}
        </Box>
    );
};

export default Header;

function useDynamicSVGImport(name: string, options: any) {
    const ImportedIconRef = React.useRef();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();

    const { onCompleted, onError } = options;
    useEffect(() => {
        setLoading(true);
        const importIcon = async () => {
            try {
                ImportedIconRef.current = (
                    await import(`./${name}.svg`)
                ).ReactComponent;
                if (onCompleted) {
                    onCompleted(name, ImportedIconRef.current);
                }
            } catch (err: any) {
                if (onError) {
                    onError(err);
                }
                setError(err);
            } finally {
                setLoading(false);
            }
        };
        importIcon();
    }, [name, onCompleted, onError]);

    return { error, loading, SvgIcon: ImportedIconRef.current };
}